import baseApi from "./baseApi"

export default  {
    /**
     * Plant Teams
     */
    async getTeams(plantID) {
        let uri = `/plantconfiguration/teams`;
        if (plantID) {
            uri = uri + `?plantID=${plantID}`;
        }

        const request = await baseApi.createHttpRequest();
        const result = await request.get(uri);
        return result.data;
    },
    async saveTeam(team) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/plantconfiguration/team", team);
        return result.data;
    },
    /**
     * Plant Units
     */
    async getPlantUnits(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/plantUnits?plantID=${plantID}`);
        return result.data;
    },
    async getActiveUnits() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/units`);
        return result.data;
    },
    async getActiveProductCategories() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/productCategories`);
        return result.data;
    },
    async getRecordingModes() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/recordingModes`);
        return result.data;
    },
    async savePlantUnit(plantID, plantUnit) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/plantconfiguration/plantUnits?plantID=${plantID}`, plantUnit);
        return result.data;
    },
    /**
     * Plant Seasons
     */
    async getPlantSeasons(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/plantSeasons?plantID=${plantID}`);
        return result.data;
    },
    async savePlantSeason(plantID, plantSeason) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/plantconfiguration/plantSeasons?plantID=${plantID}`, plantSeason);
        return result.data;
    },
    async deletePlantSeason(plantSeasonID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.delete(`/plantconfiguration/plantSeason?plantSeasonID=${plantSeasonID}`);
        return result.data;
    },
    /**
     * Plant Alerts
     */
    async getPlantAlertSettings(plantID){
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/plantAlertSettings?plantID=${plantID}`);
        return result.data;
    },
    async savePlantAlertSettings(plantID, plantAlertSettings){
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/plantconfiguration/plantAlertSettings?plantID=${plantID}`, plantAlertSettings);
        return result.data;
    },
    async getPlantAlertSecondsSettings(plantID){
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/plantAlertSecondsSettings?plantID=${plantID}`);
        return result.data;
    },
    async savePlantAlertSecondsSettings(plantID, plantAlertSecondsSettings){
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/plantconfiguration/plantAlertSecondsSettings?plantID=${plantID}`, plantAlertSecondsSettings);
        return result.data;
    },
    /**
     * Plant Inductions
     */
    async getPlantInductions(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/plantInductions?plantID=${plantID}`);
        return result.data;
    },
    async savePlantInduction(plantID, plantInduction) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/plantconfiguration/plantInductions?plantID=${plantID}`, plantInduction);
        return result.data;
    },
    /**
     * Plant Notification Subscribers
     */
    async getPlantNotificationTypes() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/notificationTypes`);
        return result.data;
    },
     async getPlantNotificationSubscribers(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/plantconfiguration/plantNotificationSubscribers?plantID=${plantID}`);
        return result.data;
    },
    async savePlantNotificationSubscriber(plantID, plantNotificationSubscriber) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/plantconfiguration/plantNotificationSubscriber?plantID=${plantID}`, plantNotificationSubscriber);
        return result.data;
    },
}